import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../src/environments/environment";
import {  tap } from "rxjs/operators";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root"
})
export class ExchageRateService {

  private apiUrl = environment.ratesapiURL;

  constructor(private httpClient: HttpClient) { }

  GetExchangeRate(): Observable<any> {
    let url = this.apiUrl;
    return this.httpClient.get<any>(url).pipe(
      tap(_ => {
        console.log("exchangeRate fetched");
      })
    );

  }
  
  
}
